/**
 * Offcanvas menu script
 *
 * Enables toggleable sub menu's for mobile navigation and clones opening hours, phone number(s) and vat-toggle from header.
 * Used to clone the menu from the header section, which is now already via PHP in the offcanvas menu middle portion.
 *
 * Created for: beboparket
 * Updated for: vloeren
 *
 * @package Theme-1
 */


// Wait for DOM to be loaded
document.addEventListener( "DOMContentLoaded", () => {

	/**
	 * Offcanvas menu 1 middle.
	 *
	 * Makes it able to toggle/navigatie submenu's.
	 */

	// Add event listeners to handle dropdown menu toggle.
	document.querySelector( ".section.offcanvas.menu .middle" ).addEventListener( "click", event => {
		if (event.target.matches(".menu-item.has-dropdown > .link")) {
			event.preventDefault();
			event.target.parentElement.classList.toggle( "active");
		} else if ( event.target.matches(".menu-item.has-sub-menu > .link" )) {
			event.preventDefault();
			event.target.parentElement.classList.toggle( "active" );
		} else if ( event.target.matches( ".dropdown > .button.back" )) {
			event.target.parentElement.parentElement.classList.toggle( "active" );
		} else if ( event.target.matches( ".sub-menu > .button.back" )) {
			event.target.parentElement.parentElement.classList.toggle( "active" );
		}
	} );

	// Add close button to dropdown menus.
	document.querySelectorAll( ".section.offcanvas.menu .middle .menu .menu-item.has-dropdown .dropdown").forEach( el => {
		el.insertAdjacentHTML( "beforeend", "<span class='component button back'></span>" );
	});
	document.querySelectorAll( ".section.offcanvas.menu .middle .menu .menu-item.has-dropdown .dropdown .sub-menu").forEach( el => {
		el.insertAdjacentHTML( "beforeend", "<span class='component button back'></span>" );
	});

	// Handle close button click.
	document.querySelector( ".button.close" ).addEventListener( "click", () => {
		document.querySelectorAll( ".section.offcanvas.menu .middle .menu .menu-item" ).forEach( el => {
			el.classList.remove( "active" );
		});
	});

	// Reset dropdown menu state on hash change.
	window.addEventListener( "hashchange", () => {
		const currentUrl = window.location.href;
		if (currentUrl.endsWith( "#" )) {
			document.querySelectorAll( ".menu-item.has-dropdown.active").forEach( el => {
				el.classList.remove("active");
			} );
			document.querySelectorAll( ".menu-item.has-sub-menu.active").forEach( el => {
				el.classList.remove( "active" );
			} );
		}
	} );


	/**
	 * Offcanvas menu 1 bottom.
	 *
	 * Clones opening hours, phone numbers and vat toggle from header.
	 */
	const offcanvas_menu_bottom = document.querySelector( ' .section.offcanvas.menu .bottom' );
	const header_opening_hours_day_components = document.querySelectorAll( '.section.header .component.opening-hours.day' );
	//const header_phone_numbers_component = document.querySelector( '.section.header .component.phone-number' );
	const header_toggle_vat_switch_component = document.querySelector( ' .section.header .component.toggle.vat-switch' );

	// The offcanvas menu bottom part element could be found.
	if ( offcanvas_menu_bottom ) {

		// // If the phone numbers component element could be found.
		// if ( header_phone_numbers_component ) {
		// 	// Clone phone numbers from header to offcanvas menu bottom.
		// 	offcanvas_menu_bottom.appendChild( header_phone_numbers_component.cloneNode(true) );
		// }

		// If the vat-switch could be found in the header.
		if ( header_toggle_vat_switch_component ) {
			// Clone the vat-switch from header to offcanvas menu bottom.
			offcanvas_menu_bottom.appendChild( header_toggle_vat_switch_component.cloneNode(true) );
		}
	}
});